var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.36 3.94a.76.76 0 0 0-.09-.85.74.74 0 0 0-.83-.21 18.76 18.76 0 0 1-12.88 0 .744.744 0 0 0-.83.21c-.2.24-.24.57-.09.85l.13.23a16.826 16.826 0 0 1-.1 15.88.76.76 0 0 0 .09.85c.2.24.53.32.82.21 4.13-1.51 8.69-1.51 12.83 0 .08.03.17.05.26.05.21 0 .42-.09.57-.26.2-.24.24-.57.09-.85a16.834 16.834 0 0 1-.1-15.87l.13-.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3.842c-.14-.39.06-.82.44-.96 1.08-.4 2.14-.91 3.18-1.52.36-.21.82-.09 1.03.26.21.36.09.82-.26 1.03a20.98 20.98 0 0 1-3.42 1.64c-.1.03-.18.04-.27.04-.31 0-.59-.19-.7-.49zM5.04 4.28c-1.16-.42-2.31-.98-3.42-1.64a.73.73 0 0 1-.26-1.02c.21-.36.67-.47 1.03-.26 1.03.61 2.1 1.12 3.18 1.52.38.14.58.57.43.96-.11.3-.4.49-.7.49-.09 0-.17-.01-.26-.05zM21.62 22.64c-1.03-.61-2.1-1.13-3.2-1.53a.75.75 0 1 1 .51-1.41c1.19.43 2.35.99 3.46 1.65.36.21.47.67.26 1.03a.77.77 0 0 1-.65.37.67.67 0 0 1-.38-.11zM1.36 22.38c-.21-.36-.1-.82.26-1.03 1.11-.66 2.27-1.22 3.46-1.65a.75.75 0 1 1 .51 1.41c-1.1.4-2.18.92-3.2 1.53a.742.742 0 0 1-1.03-.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGemini);
export default __webpack_public_path__ + "static/media/vuesax-bold-gemini.927311ad2c922c1b86dd320c4df1127b.svg";
export { ForwardRef as ReactComponent };